module.exports = __webpack_public_path__ + "static/yacht-sailing-1.dc52c584.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/universal/img/yacht-sailing-1.jpg
// module id = 841
// module chunks = 168707334958949